module.exports = __webpack_public_path__ + "img/Group-602.fa8b481b.png";